<template>
    <div class="map" ref="map" :style="'padding-bottom:'+(100/ratio)+'%;'"></div>
</template>
<style lang="scss" scoped>
    .map{
        width:100%;
        padding-bottom: 100%;
        z-index: 1;
    }
</style>
<script>
import useLeaflet from '../plugins/leaflet';

export default {
    name: 'eod-locations-map',
    props:{
        value:{
            type: Array,
            default: () => ([])
        },
        ratio:{
            type: Number|String,
            default: 1
        },
        readonly:{
            type: Boolean,
            default: false
        },
        locationFilters: {
            type: Object,
            default: () => ({})
        }
    },
    data: () => ({
        map: null,
    }),
    mounted(){
        this.initMap();
    },
    watch:{
        value(){
            this.initMap();
        }
    },
    methods:{
        async getMarkers(locations){

            const bounds = [];
            const markers = [];

            for (let i = 0; i < locations.length; i++) {
                const location = locations[i];
                let pos = null;
                if(location.locationParent == 'measurements'){
                    const {lat, lng} = await this.$eod.getLatLng(this.filters);

                    if(!lat || !lng){
                        continue;
                    }

                    pos = [lat, lng];
                }else if(location.lat && location.lon){
                    pos = [location.lat, location.lon];
                }

                if(pos){
                    bounds.push(pos);
                    
                    const marker = this.createMarker(pos);

                    let popup_html = '<div class="marker-popup">';
                    popup_html += '<h3>'+location.name+'</h3><hr class="mb-2" />';

                    const address = this.$helper.getLocationAddress(location);

                    if(address != ''){
                        popup_html += '<div>'+address+'</div>';
                    }

                    popup_html += '</div>';

                    marker.bindPopup(popup_html);

                    let tooltipEl = '<h3>'+location.name+'</h3>';

                    marker.bindTooltip(tooltipEl, {offset:[0,-20]});

                    markers.push(marker);
                }
            }

            return {markers:markers, bounds: bounds};
        },
        createMarker(pos) {
            let icon = this.$leaflet.divIcon({
                html: this.getMarkerHtml(),
                iconSize: [30, 34],
                iconAnchor: [15, 38],
                className: ''
            });

            const options = {
                icon: icon,
            }

            if(!this.readonly){
                options.draggable = 'true';
            }

            const marker = this.$leaflet.marker(pos, options);

            return marker;
        },
        getMarkerHtml() {
            return '<div class="eod-marker primary"><div class="triangle" style="border-top-color:var(--v-primary-base);"></div><i style="color:#ffffff;" class="mdi mdi-circle"></i></div>';
        },
        async initMap(){
            if (!this.$refs.map) {
                return false;
            }

            if (this.map) {
                this.map.remove();
                this.map = null;
            }

            this.map = useLeaflet(this.$refs.map, {
                zoom:13
            });

            if(this.value && this.value[0]){
                const {markers, bounds} = await this.getMarkers(this.value);
                if(bounds.length > 0){
                    this.map.fitBounds(bounds, { padding: [25, 25], maxZoom:12 });
                }
                
                this.$leaflet.layerGroup(markers).addTo(this.map);
                
            }
        }
    }
}
</script>